import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ApiError, MessageService } from '../../../../../../../core';
import { Lead } from '../../../../../lead/lead';
import { LeadSearch } from '../../../../../lead/lead-search';
import { LeadTypeaheadComponent } from '../../../../../lead/typeahead/lead-typeahead.component';
import { LeadFormContainerComponent } from '../../../../../lead/form/container';
import { LeadCrudHttpService } from '../../../../../lead/services/lead-crud-http.service';
import { take } from 'rxjs/operators';
@Component({
    selector: 'sgt-negocio-form-insert-step-lead',
    templateUrl: './negocio-form-insert-step-lead.component.html',
    styleUrls: ['./negocio-form-insert-step-lead.component.less']
})
export class NegocioFormInsertStepLeadComponent  {
    /** Se é o primeiro step */
    @Input() isFirstStep = false;

    @Input() novoLead: boolean;
    @Output() novoLeadChange = new EventEmitter<boolean>();

    leadSearch: LeadSearch;
    @Input() idLead: number;
    @Output() idLeadChange = new EventEmitter<number>();

    @Input() lead: Lead;
    @Output() leadChange = new EventEmitter<Lead>();

    @Output() idUsuarioResponsavelChange = new EventEmitter<number>();

    @Output() previus = new EventEmitter<void>();
    @Output() next = new EventEmitter<void>();
    @Output() cancel = new EventEmitter<void>();

    @ViewChild('leadForm') leadForm: LeadFormContainerComponent;
    @ViewChild('leadTypeaead') leadTypeaead: LeadTypeaheadComponent;

    constructor(private messageService: MessageService,
                private leadCrudHttpService: LeadCrudHttpService) { }

    setFocus() {
        this.leadTypeaead?.setFocus();
    }

    selectLead() {
        this.novoLead = false;
    }

    onSelected(leadSearch: LeadSearch) {
        this.leadSearch = leadSearch;
    }

    onClear() {
        this.idLead = null;
        this.leadSearch = null;
    }

    createLead(nomeLead: string) {
        this.novoLead = true;
        setTimeout(() => {
            this.leadForm.preInsert(nomeLead ? nomeLead.toUpperCase() : null);
        }, 0);
    }

    /** Carrega o lead quando informado */
    private loadLead(idLead: number): Promise<Lead> {
        return new Promise<Lead>((resolve, reject) => {
            this.leadCrudHttpService.load(idLead)
                .pipe(
                    take(1)
                )
                .subscribe(
                    lead => resolve(lead),
                    (error: ApiError) => {
                        this.messageService.error(error.message, 'Erro ao carregar o lead selecionado para criar um novo negócio', error);
                        reject(error);
                    }
                );
        });
    }

    async nextClick() {
        if (this.leadForm?.isShowPreInsertForm) {
            this.leadForm?.execConfirmPreInsert();
            return;
        }

        let idUsuarioResponsavel: number;
        // Novo lead
        if (this.novoLead) {
            const isValid = await this.leadForm?.isValid();
            if (!isValid) {
                return;
            }

            this.idLead = null;
            this.lead = this.leadForm.entity;
            idUsuarioResponsavel = this.lead.idUsuarioResponsavel;
        } else { // Lead existente
            this.idLead = this.leadSearch?.id ?? null;
            this.lead = await this.loadLead(this.idLead);
            idUsuarioResponsavel = this.leadSearch?.idUsuarioResponsavel ?? null;
        }

        this.novoLeadChange.emit(this.novoLead);
        this.idLeadChange.emit(this.idLead);
        this.leadChange.emit(this.lead);
        this.idUsuarioResponsavelChange.emit(idUsuarioResponsavel);

        this.next.emit();
    }
}
